import { render, staticRenderFns } from "./MyInvoices.vue?vue&type=template&id=088e2410&"
import script from "./MyInvoices.vue?vue&type=script&lang=js&"
export * from "./MyInvoices.vue?vue&type=script&lang=js&"
import style0 from "./MyInvoices.vue?vue&type=style&index=0&id=088e2410&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports